import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { hydrateAuth0SessionFromHash } from '../auth/hydrateSession'
import { copy } from '../lib/i18n'
import { Button } from '../ui/Button'
import { RangoAlert } from '../ui/RangoFeedback'
import { authLayoutStyles as styles, RangoAuthLayout } from '../ui/RangoAuthLayout'

/**
 * O Auth0 devolve o Link Mágico já usado ou vencido com
 * `error_description=Wrong email or verification code.` no hash.
 */
export function isUsedOrExpiredLink(hash: string): boolean {
  const params = new URLSearchParams(hash.replace(/^#/, ''))
  return /verification code/i.test(params.get('error_description') || '')
}

/**
 * Handoff pós-UL: Worker envia tokens no hash → hidrata SDK → /account.
 */
export function AuthSessionPage() {
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string
  const [ok, setOk] = useState<boolean | null>(null)
  const [linkUsed] = useState(() => isUsedOrExpiredLink(window.location.hash))

  useEffect(() => {
    try {
      const hydrated = hydrateAuth0SessionFromHash(clientId)
      setOk(hydrated)
      if (hydrated) {
        // Reload para o Auth0Provider ler o cache fresco
        window.location.replace('/account')
      }
    } catch {
      setOk(false)
    }
  }, [clientId])

  if (ok === false) {
    return (
      <RangoAuthLayout>
        <h1 className={styles.title}>
          {linkUsed ? copy.session.linkUsedTitle : copy.session.invalidTitle}
        </h1>
        <RangoAlert tone="negative">
          {linkUsed ? copy.session.linkUsedBody : copy.session.invalidBody}
        </RangoAlert>
        <div className={styles.actions}>
          {/* Raiz da própria SPA: o LoginGate já chama loginWithRedirect(),
              então o destino segue o domínio de login configurado no SDK. */}
          <Button onClick={() => window.location.assign('/')}>
            {copy.session.goToLogin}
          </Button>
        </div>
      </RangoAuthLayout>
    )
  }

  if (ok === null) {
    return (
      <RangoAuthLayout>
        <p className={styles.subtitle} role="status">
          {copy.session.finishing}
        </p>
      </RangoAuthLayout>
    )
  }

  return <Navigate to="/account" replace />
}
